import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuStateService {
  private selectedMenuSubject = new BehaviorSubject<string>('');
  selectedMenu$ = this.selectedMenuSubject.asObservable();

  private signalSubject = new BehaviorSubject<boolean>(false);
  signal$ = this.signalSubject.asObservable();

  setSelectedMenu(menuKey: string) {
    this.selectedMenuSubject.next(menuKey);
  }

  getSelectedMenu(): string {
    return this.selectedMenuSubject.getValue();
  }

  setSignal(value: boolean): void {
    this.signalSubject.next(value);
  }
}